<template>
  <file-selector v-model="files" multiple :accept="accept">
    <scroll-view v-if="hasFiles" max-height="100%">
      <reference-upload-list-item
        v-for="(file, i) in value"
        :key="i"
        :file="file"
        show-cancel
        @set-label="$emit('set-label', { file, label: $event })"
        @set-source="$emit('set-source', { file, source: $event })"
        @cancel="onDelete(file)"
      />
    </scroll-view>
  </file-selector>
</template>

<script>
import FileSelector from '@/components/Common/FileSelector';
import ScrollView from '@/components/Common/ScrollView';
import ReferenceUploadListItem from './ReferenceUploadListItem';

export default {
  name: 'ReferenceFileSelector',
  components: { FileSelector, ScrollView, ReferenceUploadListItem },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: Array,
      default: () => ['.ris', '.xml'],
    },
  },
  computed: {
    files: {
      get() {
        return this.value;
      },
      set(files) {
        this.$emit('input', files);
      },
    },
    hasFiles() {
      return this.files.length > 0;
    },
  },
  methods: {
    onDelete(file) {
      this.files = this.files.filter((f) => f !== file);
    },
  },
};
</script>
